package com.shadowings.gero.util

import androidx.compose.runtime.Composable

@Composable
actual fun AppUpdateChecker() {
    // No-op for Web target
}
